import { setCookie, getCookie } from 'tiny-cookie';

class CookieBanner {
    static cookieName = 'cookieConsent';

    constructor(bannerElement) {
        this.bannerElement = bannerElement;
        
        const isBannerEnabled = this.bannerElement.dataset.cookieBannerEnabled === 'true';

        // If banner is disabled, immediately load scripts and return
        if (!isBannerEnabled) {
            this.loadDeferredScripts();
            document.dispatchEvent(new Event('cookieConsentAccepted'));
            return;
        }

        this.acceptBtn = bannerElement.querySelector('.btn-accept');
        this.declineBtn = bannerElement.querySelector('.btn-decline');

        this.initEventListeners();
        this.checkCookieConsent();
    }

    /**
     * Initializes the CookieBanner by selecting the banner element
     * and creating a new instance if the banner is present.
     */
    static init() {
        const bannerElement = document.querySelector('.cookie-banner');
        if (bannerElement) {
            new CookieBanner(bannerElement);
        }
    }

    /**
     * Sets up event listeners for the accept and decline buttons.
     */
    initEventListeners() {
        this.acceptBtn.addEventListener('click', this.handleAccept.bind(this));
        this.declineBtn.addEventListener('click', this.handleDecline.bind(this));
    }

    /**
     * Checks the user's cookie consent status and acts accordingly.
     */
    checkCookieConsent() {
        const consent = getCookie(CookieBanner.cookieName);
        if (consent === 'accepted') {
            this.loadDeferredScripts();
            this.bannerElement.style.display = 'none';
            // Dispatch custom event after scripts are loaded
            document.dispatchEvent(new Event('cookieConsentAccepted'));
        } else if (consent === 'declined') {
            this.bannerElement.style.display = 'none';
            // Optionally add logic for declined scripts
        } else {
            this.bannerElement.style.display = 'block';
        }
    }

    /**
     * Handles the accept action by setting the consent cookie,
     * loading deferred scripts, hiding the banner, and dispatching an event.
     */
    handleAccept(event) {
        event.preventDefault();
        setCookie(CookieBanner.cookieName, 'accepted', { expires: 3650 });
        this.loadDeferredScripts();
        this.bannerElement.style.display = 'none';
        // Dispatch custom event after scripts are loaded
        document.dispatchEvent(new Event('cookieConsentAccepted'));
    }

    /**
     * Handles the decline action by setting the consent cookie
     * and hiding the banner.
     */
    handleDecline(event) {
        event.preventDefault();
        setCookie(CookieBanner.cookieName, 'declined', { expires: 1 });
        this.bannerElement.style.display = 'none';
        // Optionally add logic for declined scripts
    }

    /**
     * Loads deferred scripts by creating new script elements
     * and appending them to the document head.
     */
    loadDeferredScripts() {
        const scripts = Array.from(document.querySelectorAll('script.deferred-script'));

        scripts.forEach(oldScript => {
            const src = oldScript.getAttribute('data-src');
            if (src) {
                // Create new script element
                const newScript = document.createElement('script');
                
                // Copy all attributes from old script to new script
                Array.from(oldScript.attributes).forEach(attr => {
                    if (attr.name !== 'data-src' && attr.name !== 'class') {
                        newScript.setAttribute(attr.name, attr.value);
                    }
                });
                
                // Set src attribute
                newScript.src = src;
                
                // Copy any inline script content
                newScript.textContent = oldScript.textContent;
                
                // Replace old script with new one
                oldScript.parentNode.replaceChild(newScript, oldScript);
            }
        });
    }
}

export default CookieBanner;
